import { createFileRoute } from "@tanstack/react-router";
import WhatIsInterventionalPsychiatry from "@/pages/articles/WhatIsInterventionalPsychiatry";
export const Route = createFileRoute("/what-is-interventional-psychiatry")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "What Is Interventional Psychiatry | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "What is interventional psychiatry? Learn about TMS, SAINT TMS, SPRAVATO, and ketamine for treatment-resistant depression in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "What Is Interventional Psychiatry | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "What is interventional psychiatry? Learn about TMS, SAINT TMS, SPRAVATO, and ketamine for treatment-resistant depression in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/what-is-interventional-psychiatry",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/what-is-interventional-psychiatry",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WhatIsInterventionalPsychiatry />;
}
